import { Color, ID, WINDOW_WIDTH } from "src/libs/interfaces/layouts";
import { create } from "zustand";
import {
  createJSONStorage,
  devtools,
  persist,
  subscribeWithSelector,
} from "zustand/middleware";
import { IPanelPosition } from "../views/UIX/Panel";
import {
  Border,
  CardFiled,
  CardsContent,
  defaultLanding,
  ICard,
  IContentSelect,
  ICurrentEditType,
  IHistoryStep,
  ILanding,
  LANDING_EDIT_MODE,
  LANDING_PRIMITIVE_PIN,
  LANDING_PRIMITIVE_TYPE,
  SELECT_TYPE,
} from "./interfaces";
import { getStorage } from "src/settings/zustand";
import { ANIMATE_DELAY, ANIMATED_STYLE } from "src/libs/interfaces/animated";

export interface ILandingStore {
  isEdit: boolean;
  currentLanding: ILanding;
  updateLanding: (landing: ILanding) => void;
  currentSource: string[]; // массив: [локальный адрес файлов .jsonб название лоуального файла]
  landingRect: DOMRect;
  isSectionEdit: boolean;
  isDrag: boolean;
  setDrag: (isDrag: boolean) => void;
  sectionEditTab: string;
  sectionEditMeatID: ID;
  schema: string;
  currentEditData: any; // данные для панели редактирования SectionEditDrawer.tsx
  readyToClose: boolean; // панель редактирования можно закрывать ( данные редактирования сохранены )

  //layers panel
  selectedElements: any[]
  selectedSectionId?: ID
  selectedElementsType?: SELECT_TYPE.CONTENT | SELECT_TYPE.FLOAT

  isMakeupDrawerOpen: boolean; //
  makeupType: SELECT_TYPE;

  isAddMeatDrawerOpen: boolean; //
  addMeatDrawerSectionId: ID | undefined;
  addMeatDrawerMeatId: ID | undefined;

  needUpdate: boolean; // глобальные данные страницы изменены. Необходим апдейт

  // edit modal
  curEditModal: ICurrentEditType | undefined;
  curEditModalTab: string | undefined;

  // hover
  hoverElement: IHoverElement | undefined;

  // click
  selectedLayer: ID; // Выделенная секция (Section)
  editElement: IContentSelect | null; // редактируемый элемент (ContentDoubleClickForm.tsx)
  selectedMeat: ID;
  selectedFloat: ID;
  selectedType: SELECT_TYPE;

  zoom: number;
  translateX: number;
  translateY: number;
  setDefaultZoom: () => void;

  // double click
  doubleClickSectionID: ID;
  doubleClickType: SELECT_TYPE;
  doubleClickDataID: ID;

  // cards edit
  currentCardEdit: CardsContent | null;
  selectedCardField: CardFiled | null;
  cardFieldsPositions: IPanelPosition;
  cardFieldSinglePositions: IPanelPosition;
  onDeleteCardField: (cf: CardFiled) => void;
  onVisibleCardField: (cf: CardFiled) => void;
  onDownCardField: (cf: CardFiled) => void;

  copyData: any;
  onCopy: (data: any) => void;
  onPaste: () => any;
  history: IHistoryStep[];
  currentHistoryStep: number;
  isLocal: boolean
  modals: string[];
  landing_id: ID;
  land_id: ID
}

export interface ILandingConsoleStore {
  editMode: LANDING_EDIT_MODE;
  figureMode: LANDING_PRIMITIVE_TYPE | typeof LANDING_PRIMITIVE_PIN;
  settings: any;
  width: number;
  isEdit: boolean;
  isLayers: boolean;
  isLayersTread: boolean;
  isMeat: boolean;
  isMeatTread: boolean;
  layersPositions: IPanelPosition;
  meatPositions: IPanelPosition;
  currentDimensionEdit: WINDOW_WIDTH; // текущая размерность экрана ( WINDOW_WIDTH.PANEL by default )
  color: Color;
  border: Border;
  animationType: ANIMATED_STYLE[];
  animationDelay: ANIMATE_DELAY;
  linkFeedCategories?: ID[],
  modals: ID[],
  modalsOpen: ID[],
}

export const useLandingConsoleStore: any = create(
  devtools(
    persist<ILandingConsoleStore>(
      (set: any, get: any) => ({
        editMode: LANDING_EDIT_MODE.EDIT,
        figureMode: LANDING_PRIMITIVE_TYPE.RECTANGLE,
        settings: {
          lines: true,
          topPanel: true,
          panels: true,
          toolPanel: true,
        },
        width: 250,
        isEdit: false,
        isLayers: true,
        isLayersTread: true,
        isMeat: true,
        isMeatTread: true,
        color: "var(--red)",
        border: {
          stroke: "#000",
          strokeWidth: 1,
        },
        layersPositions: { x: 1500, y: 200, w: 280, h: 390 },
        meatPositions: { x: 200, y: 400, w: 280, h: 390 },
        currentDimensionEdit: WINDOW_WIDTH.PANEL,
        animationType: [ANIMATED_STYLE.FADE_IN],
        animationDelay: ANIMATE_DELAY.WATERFALL,
        linkFeedCategories: [],
        modals:[],
        modalsOpen:[],
      }),
      {
        name: "pe-landing-console-storage",
        storage: createJSONStorage(getStorage),
      },
    ),
  ),
);
export const useLandingStore: any = create(
  devtools(
    subscribeWithSelector<ILandingStore>((set: any, get: any) => ({
      land_id: "",
      landing_id: "",
      isEdit: false,
      isDrag: false,
      setDrag: (isDrag: boolean) => set(() => ({ isDrag })),
      currentLanding: defaultLanding(),
      updateLanding: (landing: ILanding | any) => {
        if (!landing.currentLanding) {
          landing = { currentLanding: landing };
        }
        set({
          ...landing,
          // needUpdate: true
        });
      },
      currentSource: ["", ""],
      landingRect: {} as DOMRect,
      isSectionEdit: false,
      sectionEditTab: "main",
      sectionEditMeatID: "",

      // edit drawer
      schema: "Section",
      currentEditData: {},
      readyToClose: true,
      cardFieldsPositions: { x: 50, y: 200, w: 280, h: 390 },
      cardFieldSinglePositions: { x: 550, y: 200, w: 400, h: 400 },
      needUpdate: false,

      //layers panel
      selectedElements: [],
      selectedSectionId: undefined,
      selectedElementsType: undefined,


      isMakeupDrawerOpen: false,
      makeupType: SELECT_TYPE.NONE,
      //
      isAddMeatDrawerOpen: false,
      addMeatDrawerSectionId: undefined,
      addMeatDrawerMeatId: undefined,

      // edit modal
      curEditModal: undefined,
      curEditModalTab: undefined,

      // hover
      hoverElement: undefined,

      // click
      selectedLayer: "",
      selectedMeat: "",
      selectedFloat: "",
      selectedType: SELECT_TYPE.NONE,
      editElement: null,

      selectedCardField: null,
      currentCardEdit: null,
      zoom: 100,
      translateX: 0,
      translateY: 0,
      setDefaultZoom: () =>
        set(() => ({ zoom: 100, translateX: 0, translateY: 0 })),
      onDeleteCardField: (cf: CardFiled) => {
        const currentCardEdit = useLandingStore.getState().currentCardEdit;
        const i: number = currentCardEdit.card_fields.findIndex(
          (casrdField: CardFiled) => cf.id === casrdField.id,
        );
        // меняем поля шаблона
        currentCardEdit.card_fields.splice(i, 1);
        // меняем порядок
        currentCardEdit.order.splice(i, 1);
        // меняем значения всех карточек
        currentCardEdit.cards.forEach((card: ICard) => {
          card.value.splice(i, 1);
        });
        useLandingStore.setState({ currentCardEdit });
      },
      onVisibleCardField: (cf: CardFiled) => {
        const currentCardEdit = useLandingStore.getState().currentCardEdit;
        const i: number = currentCardEdit.card_fields.findIndex(
          (casrdField: CardFiled) => cf.id === casrdField.id,
        );
        let order = currentCardEdit.order;
        if (order.includes(cf.type)) {
          order = order.filter((o: string) => o !== cf.type);
        } else {
          order.splice(i, 0, cf.type);
        }
        useLandingStore.setState({
          currentCardEdit: { ...currentCardEdit, order },
        });
      },
      onDownCardField: (cf: CardFiled) => {
        const currentCardEdit = useLandingStore.getState().currentCardEdit;
        const i: number = currentCardEdit.card_fields.findIndex(
          (casrdField: CardFiled) => cf.id === casrdField.id,
        );
        // меняем поля шаблона
        currentCardEdit.card_fields.splice(i + 2, 0, cf);
        currentCardEdit.card_fields.splice(i, 1);
        // меняем порядок
        currentCardEdit.order.splice(i + 2, 0, cf.type);
        currentCardEdit.order.splice(i, 1);
        // меняем значения всех карточек
        currentCardEdit.cards.forEach((card: ICard) => {
          const value = card.value[i];
          card.value.splice(i + 2, 0, value);
          card.value.splice(i, 1);
        });
        useLandingStore.setState({ currentCardEdit });
      },

      // double click
      doubleClickSectionID: "",
      doubleClickType: SELECT_TYPE.NONE,
      doubleClickDataID: "",

      copyData: {},
      onCopy: (data: any) => set(() => ({ copyData: data })),
      onPaste: () => {
        return useLandingStore.getState().copyData;
      },
      history: [],
      currentHistoryStep: 0,
      modals: [],
      isLocal: true,
    })),
  ),
);

export interface IHoverElement {
  sectionId: ID;
  id: ID;
  selectType: SELECT_TYPE;
  bound: Partial<DOMRect>;
  cursor?: string; // cards, section...
}
